/* lua.js generated code 0.3.0 */

var HomeSceneAnimBase = require("clover/scene/component/homescene/homeSceneAnim/HomeSceneAnimBase")
var FishSchool = xClass("FishSchool", HomeSceneAnimBase)
FishSchool.prototype.ctor = function () {
    var self = this
    HomeSceneAnimBase.prototype.ctor.call(self)
    var animNode = cc.CSLoader.createNode("cocos/homeAnim_fish_fish_animation_all.csb")
    var animation = cc.CSLoader.createTimeline("cocos/homeAnim_fish_fish_animation_all.csb")
    animNode.runAction(animation)
    animation.gotoFrameAndPlay(0, 160, true)
    self.anim = animation
    animNode.setPosition(-10, 0)
    self.addChild(animNode)
}
FishSchool.prototype.pause = function () {
    var self = this
    self.anim.pause()
}
FishSchool.prototype.resume = function () {
    var self = this
    self.anim.resume()
}
module.exports = FishSchool
